import { cn } from '@/shared/ui'

/** One placeholder block, hidden from assistive technology; size it with `className`. */
export function Skeleton(props: { readonly className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('block animate-pulse rounded bg-background-contrast-sm', props.className)}
    />
  )
}

/**
 * Stands in for a page's content while it loads: a status that says what is loading, over the
 * rough shape of a heading and a few cards. Skeletons, not spinners (ADR-AA015).
 */
export function PageSkeleton(props: { readonly label: string; readonly className?: string }) {
  return (
    // <output> carries role="status" semantics without ARIA.
    <output className={cn('flex w-full flex-col gap-6', props.className)}>
      <span className="sr-only">{props.label}</span>
      <Skeleton className="h-8 w-64 max-w-full" />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
      </div>
    </output>
  )
}
